import { defineStore } from "pinia";
import moment from "moment";
import { dashboardService } from "@/_services";

export const dashboardStore = defineStore("dashboard", {
  state: () => ({
    date: null,
    overview: {},
    progress: [],
    fleet: [],
    error: null,
  }),
  actions: {
    getDashboard(date= "") {
      this.date = null
      this.overview = {}
      this.progress = []
      this.fleet = []
      this.error = null
      dashboardService
        .getDashboard(date)
        .then((result) => {
          this.date = result?.date ? moment(result.date) : null
          this.overview = JSON.parse(JSON.stringify(result?.overview || {}))
          this.progress = [...(result?.progress || [])]
          this.fleet = [...(result?.fleet || [])]
        })
        .catch((reason) => (this.error = reason));
    },
  },
});
